import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    {...props}
  >
    <path
      fill="#3D1B00"
      d="M4.666.977H0v4.666h4.666V.977ZM10.846.977H6.18v4.666h4.666V.977ZM17.03.977h-4.667v4.666h4.666V.977ZM4.666 7.156H0v4.666h4.666V7.156ZM10.846 7.156H6.18v4.666h4.666V7.156ZM17.03 7.156h-4.667v4.666h4.666V7.156ZM4.666 13.328H0v4.666h4.666v-4.666ZM10.846 13.328H6.18v4.666h4.666v-4.666ZM17.03 13.328h-4.667v4.666h4.666v-4.666Z"
    />
  </svg>
)
export default SvgComponent
